import React from 'react';
import PropTypes from 'prop-types';

const DevicePortraitPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M24 25.009A2.993 2.993 0 0 1 20.99 28h-9.98A3.002 3.002 0 0 1 8 25.009V6.99A2.993 2.993 0 0 1 11.01 4h9.98A3.002 3.002 0 0 1 24 6.991V25.01zM10 8h12v16H10V8z"
    />
  );
};

DevicePortraitPath.propTypes = {
  fill: PropTypes.string,
};

export default DevicePortraitPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/device-portrait.jsx